import Immutable from 'immutable';
import { PageId } from 'records/Page';
import { RawRFIAttachment, RFIAttachment } from 'records/RFIAttachment';
import { User } from 'records/User';
import { SheetVersion } from './SheetVersion';

export interface RawRFIForwardActivity {
  message: string;
  attachments: RawRFIAttachment[];
  email: string;
  timestamp: number;
  id: string;
  pageids: string[];
  sheetVersions: undefined;
  user: undefined;
}

export interface RFIForwardActivityData {
  message: string;
  attachments: Immutable.List<RFIAttachment>;
  email: string;
  timestamp: number;
  id: string;
  pageids: Immutable.Set<PageId>;
  sheetVersions: Immutable.List<SheetVersion>;
  user: User;
}

const defaultValues: RFIForwardActivityData = {
  message: '',
  attachments: Immutable.List<RFIAttachment>(),
  email: '',
  timestamp: 0,
  id: '',
  pageids: Immutable.Set<PageId>(),
  sheetVersions: Immutable.List<SheetVersion>(),
  user: new User(),
};

export const RFIForwardActivityFactory = Immutable.Record(
  defaultValues,
  'RFIForwardActivity'
);

export class RFIForwardActivity extends RFIForwardActivityFactory {
  static deserialize(
    rawRFIForwardActivity: RawRFIForwardActivity
  ): RFIForwardActivity {
    const attachments = Immutable.List<RFIAttachment>(
      rawRFIForwardActivity.attachments.map(RFIAttachment.deserialize)
    );

    return new RFIForwardActivity({
      ...rawRFIForwardActivity,
      pageids: Immutable.Set(rawRFIForwardActivity.pageids),
      attachments,
    });
  }

  serialize(): RawRFIForwardActivity {
    return this.toJS();
  }
}
